var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopAssistantClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 9.00033C0.666748 4.40514 4.4049 0.666992 9.00008 0.666992C13.5953 0.666992 17.3334 4.40514 17.3334 9.00033C17.3334 13.5955 13.5953 17.3337 9.00008 17.3337C4.4049 17.3337 0.666748 13.5955 0.666748 9.00033ZM12.4724 13.5143C12.6501 13.5143 12.8279 13.4461 12.9633 13.3107C13.2348 13.0392 13.2348 12.6004 12.9633 12.3288L9.69451 9.06009V4.83366C9.69451 4.44965 9.38348 4.13926 9.00011 4.13926C8.61673 4.13926 8.3057 4.44965 8.3057 4.83366V9.34759C8.3057 9.53222 8.37857 9.70871 8.50916 9.83854L11.9814 13.3107C12.1167 13.4461 12.2946 13.5143 12.4724 13.5143Z",
    fill: "#659B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopAssistantClock);
export default __webpack_public_path__ + "static/media/ShopAssistantClock.ec72965065796a2411f4dd48a5032c27.svg";
export { ForwardRef as ReactComponent };